import { User } from '.';

export interface GroupLead {
  groupLeadId: number;
  groupId: number;
  emailAddress: string;
  user?: User;
  isPrimary: boolean;
}

export function blankgroupLead(): GroupLead {
  return {
    groupLeadId: 0,
    groupId: 0,
    emailAddress: '',
    isPrimary: false
  };
}

export function copyGroupLead(groupLead: GroupLead): GroupLead {
  return {
    groupLeadId: groupLead.groupLeadId,
    groupId: groupLead.groupId,
    emailAddress: groupLead.emailAddress,
    isPrimary: groupLead.isPrimary,
  };
}

export function compareGroupLead(groupLeadA: GroupLead, groupLeadB: GroupLead): boolean {
  return groupLeadA.emailAddress === groupLeadB.emailAddress &&
    groupLeadA.isPrimary === groupLeadB.isPrimary;
}